import Crud from '../views/Unidade/Crud'
import Entity from '../views/Unidade/Add'

let routes = {
    path: '/unidades',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/unidades/add',
            name: 'NewUnidade',
            component: Entity,
            meta: {
                pageTitle: 'Adicionar Unidades ',
                breadcrumb: [
                    {
                        text: 'Unidade',
                        active: false,
                        to: '/unidades',
                    },
                    {
                        text: 'criar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/unidades/edit/:id?',
            name: 'EditUnidade',
            component: Entity,
            meta: {
                pageTitle: 'Editar Unidade',
                breadcrumb: [
                    {
                        text: 'Unidade',
                        active: false,
                        to: '/unidades',
                    },
                    {
                        text: 'editar',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/unidades',
            name: 'list-unidades',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Unidades',
                breadcrumb: [
                    {
                        text: 'Unidades',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
